<template>
    <div class="depart">
        <div class="blueInfo" style="display: flex; align-items: center;">
            <i class="el-icon-warning" style="color: #409EFF; margin-right: 5px; font-size: 16px;"></i>
            启用发车限制后，我们将限制该线路班次的司机最早出发接乘客的时间
        </div>
        <div class="depart-content">
            <el-form ref="departForm" label-width="120px" :model="departForm" :rules="departRules">
                <el-form-item label="是否限制" prop="departureRestrictions">
                    <el-radio-group v-model="departForm.departureRestrictions">
                        <el-radio :label="0">不限制</el-radio>
                        <el-radio :label="1">要限制</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="最早出发时间" prop="departureRestrictionsConfig" v-if="departForm.departureRestrictions">
                    <el-input v-model="departForm.departureRestrictionsConfig" v-input-filter="{min: 1, max: 999, precision: 0}">
                        <template slot="append">分钟接人</template>
                        <template slot="prepend">可提前</template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="savedepartConfig">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
    <!--  -->
</template>

<script>
export default {
    props: {
        config: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            departForm: {
                lineId: null,
                departureRestrictionsConfig: 30,
                departureRestrictions: 0,
            },
            departRules: {
                departureRestrictionsConfig: [{ required: true, message: '请输入最早出发时间' }],
                departureRestrictions: [{ required: true, message: '请选择是否开启限制' }],
            },
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.departForm.departureRestrictions = this.config.departureRestrictions;
            this.departForm.departureRestrictionsConfig = this.config.departureRestrictionsConfig || 30;
            this.departForm.lineId = this.config.lineId
        },
        async savedepartConfig() {
            this.$refs.departForm.validate(async (valid) => {
                if (valid) {
                    let params = {
                        id: this.departForm.lineId,
                        departureRestrictions: this.departForm.departureRestrictions,
                        departureRestrictionsConfig: this.departForm.departureRestrictions == 1 ? this.departForm.departureRestrictionsConfig : null
                    };
                    let url = "/api/v1/manage/line/departureRestrictions";
                    let data = await this.$axios.put(url, params);
                    if (data && data.code === 1) {
                        this.$message.success("已更换规则");
                        this.$emit('success')
                    }
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.depart {

    .depart-content {
        width: 550px;
    }
}
</style>
